import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './components/Login';
import AccessDenied from './components/AccessDenied';
import ProtectedApp from './components/ProtectedApp';

const App: React.FC = () => {
  const { user, loading, isAllowed, token } = useAuth();

  // Show loading while authenticating or fetching token
  if (loading || (user && !token)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <p>Ładowanie...</p>
      </div>
    );
  }

  // If user tried to authenticate but is not allowed, show access denied
  if (isAllowed === false && user === null) {
    return <AccessDenied />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={user && token ? <Navigate to="/tasks-list" replace /> : <Login />}
        />
        <Route
          path="*"
          element={user && token ? <ProtectedApp /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;